import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './css/Navbar.css';

const Navbar: React.FC = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [activeDropdown, setActiveDropdown] = useState<string | null>(null);
    const location = useLocation();
    const dropdownRef = useRef<HTMLDivElement>(null);

    const isActive = (path: string) => {
        if (path === '/') {
            return location.pathname === '/';
        }
        return location.pathname.startsWith(path);
    };
    const closeAll = () => {
        setIsMenuOpen(false);
        setActiveDropdown(null);
    };

    const toggleDropdown = (dropdownName: string, event?: React.MouseEvent) => {
        if (event) {
            event.stopPropagation();
        }
        setActiveDropdown(activeDropdown === dropdownName ? null : dropdownName);
    };

    const handleDropdownLinkClick = (event: React.MouseEvent) => {
        event.stopPropagation();
        closeAll();
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setActiveDropdown(null);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        closeAll();
    }, [location]);

    const newsItems = [
        // { id: 1, label: 'Эрдэнэт ХБАХТ', path: '/news-information/local' },
        { id: 2, label: 'Мэдээ', path: '/news-information/news' },
        { id: 3, label: 'Статистик', path: '/news-information/statistic' },
    ];

    return (
        <div className="navbar-container">
            <div className="navbar-content">
                <div className="navbar-logo">
                    <Link to="/" onClick={closeAll}>
                        <span className="logo-text">Хойд бүсийн авто худалдааны төв</span>
                    </Link>
                </div>

                <div className={`navbar-links ${isMenuOpen ? 'mobile-open' : ''}`} ref={dropdownRef}>
                    <Link to="/" onClick={closeAll}>
                        <span className={`nav-link-underline ${isActive('/') ? 'active' : ''}`}>Нүүр</span>
                    </Link>
                    {/* <Link to="/aBlock" onClick={closeAll}>
                        <span className={`nav-link-underline ${isActive('/aBlock') ? 'active' : ''}`}>А Блок </span>
                    </Link>
                    <Link to="/bBlock" onClick={closeAll}>
                        <span className={`nav-link-underline ${isActive('/bBlock') ? 'active' : ''}`}>Б Блок </span>
                    </Link> */}
                    {/* <div className="nav-dropdown">
                        <div
                            className={`nav-dropdown-toggle ${isActive('/about') ? 'active' : ''}`}
                            onClick={(e) => toggleDropdown('about', e)}
                        >
                            <span>Бидний тухай</span>
                            <span className={`dropdown-arrow ${activeDropdown === 'about' ? 'open' : ''}`}></span>
                        </div>
                        <div className={`nav-dropdown-menu ${activeDropdown === 'about' ? 'open' : ''}`}>
                            {aboutItems.map(item => (
                                <Link
                                    key={item.id}
                                    to={item.path}
                                    onClick={handleDropdownLinkClick}
                                    className={`nav-dropdown-item ${isActive(item.path) ? 'active' : ''}`}
                                >
                                    {item.label}
                                </Link>
                            ))}
                        </div>
                    </div> */}

                    <div className="nav-dropdown">
                        <div
                            className={`nav-dropdown-toggle ${isActive('/news-information') ? 'active' : ''}`}
                            onClick={(e) => toggleDropdown('news', e)}
                        >
                            <span>Мэдээ мэдээлэл</span>
                            <span className={`dropdown-arrow ${activeDropdown === 'news' ? 'open' : ''}`}></span>
                        </div>
                        <div className={`nav-dropdown-menu ${activeDropdown === 'news' ? 'open' : ''}`}>
                            {newsItems.map(item => (
                                <Link
                                    key={item.id}
                                    to={item.path}
                                    onClick={handleDropdownLinkClick}
                                    className={`nav-dropdown-item ${isActive(item.path) ? 'active' : ''}`}
                                >
                                    {item.label}
                                </Link>
                            ))}
                        </div>
                    </div>

                    {/* <Link to="/listing" onClick={closeAll}>
                        <span className={`nav-link-underline ${isActive('/listing') ? 'active' : ''}`}>Автомашин</span>
                    </Link> */}
                    <Link to="/location" onClick={closeAll}>
                        <span className={`nav-link-underline ${isActive('/location') ? 'active' : ''}`}>Холбоо барих</span>
                    </Link>
                    {/* <Link to="/feedback" onClick={closeAll}>
                        <span className={`nav-link-underline ${isActive('/feedback') ? 'active' : ''}`}>Санал гомдол</span>
                    </Link> */}
                </div>
                <div className="navbar-toggle" onClick={() => setIsMenuOpen(!isMenuOpen)}>
                    <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></span>
                    <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></span>
                    <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></span>
                </div>
            </div>
        </div>
    );
};

export default Navbar;